export enum PaymentStatusEnum {
  INCOMPLETE = 'INCOMPLETE',
  TRIAL = 'TRIAL',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
}
